import axios from '../axios';
import * as models from './models';
import { OrderRefSearch } from './orders';

export function Shipments(hyejooRequestInit: models.IHyejooRequest, organizationParams?: { organization?: string }): Promise<models.ShipmentsHyejooResponse> {
    return axios.get('/v2/shipments', {
        params: Object.assign(new models.HyejooRequest(hyejooRequestInit), organizationParams),
    }).then(r => models.ShipmentsHyejooResponse.fromJSON(r.data));
}

// OrderShipments is the live state of an order's packages: every parent shipment
// except a leg we know went elsewhere, with carrier tracking.
// orderRef is an order id, a 32-byte key (reads signed out), or an invoice
// number.
export async function OrderShipments(orderRef: string, req: { data: string; organization?: string }): Promise<models.HyejooShipment[]> {
    const search = OrderRefSearch(orderRef, 'order');
    const resp = await Shipments({
        q: `${search.q} parent:true`,
        data: req.data,
        // Unlimited: the search is one order, and a page cap would drop packages.
        max: -1,
        sort: 'created asc',
    }, { organization: req.organization });
    return resp.results;
}
